import axios from 'axios';

import { Url } from '../constants/Global';


export default axios.create({
    baseURL: Url.BASE
});